// extracted by mini-css-extract-plugin
export default {"adminPanelHeader":"adminPanelHeader_adminPanelHeader__6Z92E"};